// ShareButton.jsx
// ShareButton.jsx
import React from "react";
import { ShareIcon } from "@heroicons/react/24/outline";

const ShareButton = ({ onClick }) => {
  return (
    <button
      className="text-gh_black-100 hover:text-blue-500 focus:outline-none"
      onClick={onClick}
    >
      <ShareIcon className="w-5 h-5" />
    </button>
  );
};

export default ShareButton;
